<template>
    <div id="about">
        <div class="title">关于中信</div>
        <div class="aboutus">
            <div class="left">
                中国中信集团公司的前身是中国国际信托投资公司，是经改革开放总设计师邓小平亲自倡导和批准，由前国家副主席荣毅仁于1979年10月4日创办。2002年中国国际信托投资公司进行体制改革，成为隶属于国务院直接管理和授权的投资机构。
                <br>
                <br>
                2011年中国中信集团公司整体改制为国有独资公司，更名为中国中信集团有限公司（简称“中信集团”），并发起设立了中国中信股份有限公司（简称“中信股份”）。
            </div>
            <div class="img">
                <img src="../../../static/business-about-img.png" style="width: 100%;height:100%;" alt="">
            </div>
        </div>
        <div class="number">
            <div class="item">
                <div class="num">100+</div>
                <div class="text">
                    业务覆盖国民经济中的60多个领域，在全球60多个国家设立了100多家机构开展业务
                </div>
            </div>
            <div class="item">
                <div class="num">90+</div>
                <div class="text">
                    在全球14个国家营运建设超过90多个大型项目，并带动大量国内产能出口
                </div>
            </div>
            <div class="item">
                <div class="num">8+15</div>
                <div class="text">
                    中信投资、中国建筑承建的北京新地标中信大厦创造了超高层建筑的8项世界纪录和15项中国纪录
                </div>
            </div>
        </div>
        <div class="info">
            <img src="../../../static/business-about-lbb.png" style="width: 100%;" alt="">
            <el-carousel ref="carousel" class="lunbo" :interval="5000" height="160px" arrow="never"
                @current-change="handleCarouselChange">
                <el-carousel-item>
                    <div class="text">
                        中信集团具备卓越的专业化服务能力，在综合金融服务领域，中信证券、中信信托等长期处于证券、信托行业领先地位，实力雄厚、优势明显；在工程承包领域，中信建设整合国内外优质资源打造“中信联合舰队”的创新商业模式，在消费领域，中信联合体收购麦当劳中国业务，成为麦当劳在美国本土以外最大的特许经营商。
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="text">
                        在先进制造领域，中信戴卡与英国威廉姆斯车队建立战略合作，为其研制F1比赛使用车轮，使中国制造第一次以生产技术研发形式进入世界顶级汽车赛事；在金融科技领域，中信银行与百度牵手，成立中国首家独立法人实体的直销银行；在“互联网+转型”领域，“中信云”平台已集成了阿里、腾讯、百度等战略合作伙伴，为企业用户提供优质的基础设施、技术平台、软件应用和云计算等服务。
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="text">
                        中信银行成立于1987年，是中国改革开放中最早成立的新兴商业银行之一，是中国最早参与国内外金融市场融资的商业银行，并以屡创中国现代金融史上多个第一而蜚声海内外，为中国经济建设做出了积极贡献。2007年4月，本行实现在上海证券交易所和香港联合交易所A+H股同步上市。经过30余年的发展，本行已成为一家总资产规模超9万亿元、员工人数超6.5万名，具有强大综合实力和品牌竞争力的金融集团。
                        <!-- 2023年，本行在英国《银行家》杂志“全球银行品牌500强排行榜”中排名第20位；本行一级资本在英国《银行家》杂志“世界1000家银行排名”中排名第19位。 -->
                    </div>
                </el-carousel-item>
            </el-carousel>
            <img class="lunbo-btn" src="../../../static/icon-arrow-right-bg.png" @click="goToSlide('next')">
        </div>
        <div class="tabinfo">
            <div class="tab">
                <div class="item" v-for="(item, ind) of tabData" :key="ind" @click="checkTab(ind)">
                    <div :class="['text', tabDataInd == ind ? 'on' : '']">{{ item.title }}</div>
                    <div :class="['line', tabDataInd == ind ? 'on' : '']"></div>
                </div>
            </div>
            <div class="line" style="width: 100%;height: 1px;background-color: #E8E8E8;"></div>
            <div class="list">
                <div class="box" :style="'left: -'+tabListScroll+'px;'">
                    <div class="item" v-for="(item, ind) of TabData" :key="ind">
                        <img :src="item.coverOssUrl" style="width: 320px;height: 200px;" alt="">
                        <div class="right">
                            <div class="list-title">{{ item.name }}</div>
                            <div class="text">{{ item.sketch }}</div>
                            <div class="btn" @click="jumpDet(item)">查看详情</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        TabData:{
            type: Array,
            default: []
        }
    },
    data() {
        return {
            carouselInd: 0,
            tabData: [{
                title: '综合金融',
                img: "businessTabImg1",
                text: '综合金融板块致力于成为国际一流、国内领先的综合金融服务引领者，将打造统一金控平台，积极落实金融供给侧结构性改革及金融监管政策，以客户为中心，加大融融协同、产融协同力度，不断提高金融科技实力，有效防范化解风险，着力提升金融服务实体经济能力。'
            }, {
                title: '先进智造',
                img: "businessTabImg2",
                text: '先进智造板块致力于成为弯道超车领域的开拓者，立足制造强国，努力在“卡脖子”关键领域实现突破，力争成为中国先进制造业的排头兵；深入特种机器人、工业软件、芯片产业链等战略性新兴产业，拓展军民融合领域布局，并持续强化在汽车零部件和重型机械等领域的领先优势。'
            }, {
                title: '先进材料',
                img: "businessTabImg3",
                text: '先进材料板块致力于成为产业链安全的保障者，努力在传统领域提高环保效能，在新兴领域填补空白，维护产业链供应链稳定，全力保障国家战略资源安全； 大力发展汽车轻量化材料、高强度钢材、高强度合金等特种材料，力争在特种新材料上填补国内空白、在特种原材料上弥补国家稀缺资源。'
            }, {
                title: '新消费',
                img: "businessTabImg4",
                text: '新消费板块致力于成为新消费趋势的推动者、激发和释放内需的先行者，把握数字消费和文化消费升级的市场机遇，持续推进数字化转型升级，深化文化创意产业发展，形成中信消费品牌，助力保障国家粮食安全，提高农业质量效益和竞争力。'
            }, {
                title: '新型城镇化',
                img: "businessTabImg5",
                text: '新型城镇化板块致力于成为智慧城市的营建者，积极融入区域战略，提供集规划、设计、投融资、建设、开发、运营于一体的智慧城市解决方案；助力国家重大区域战略，以京津冀、粤港澳、长三角、成渝经济圈等城市群为主战场，促进新型城镇化提质升级。'
            }],
            tabDataInd: 0,
            tabListScroll: 0,
            pageInfo: {
                pageSize: 10,
                pageNum: 1,
                pageTotal: 2,
            },
        }
    },
    created() {
        console.log(this.TabData);
    },
    methods: {
        // 跳转文章详情
        jumpDet(v) {
            this.$router.push({
                path: "/articleDet", query: {
                    pageType: 'ywbk',
                    pageName: "投贷联动",
                    ...v
                }
            });
        },
        // 获取Tab数据
        getBusinessListData() {
            this.businessList = [];
            this.pageLoding = false;
            this.$api.getBusinessList({
                classify: 5,
                ...this.pageInfo
            }).then(res => {
                // this.tabData = res.rows;
                console.log(res.rows);
                this.pageInfo.pageTotal = res.total;
                this.pageLoding = true;
            })
        },
        checkTab(ind) {
            this.tabDataInd = ind;
            this.tabListScroll = 850 * ind;
        },
        handleCarouselChange(newIndex) {
            this.carouselInd = newIndex
        },
        goToSlide(type) {
            if (type == 'prev') {
                this.$refs.carousel.setActiveItem(this.carouselInd--);
            }
            if (type == 'next') {
                if (this.carouselInd == 2) {
                    this.carouselInd = 0;
                } else {
                    this.carouselInd++;
                }
                this.$refs.carousel.setActiveItem(this.carouselInd);
            }
        },
    },
}
</script>

<style lang="less" scoped>
* {
    color: #666;
}

#about {
    margin-bottom: 50px;
    font-size: 16px;
    line-height: 32px;
}

.title {
    color: #333;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
}

.aboutus {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .left {
        width: 50%;
        font-size: 16px;
        padding-right: 130px;
    }

    .img {
        width: 58%;
    }
}

.number {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 120px;

    .item {
        width: 28%;
    }

    .num {
        color: #1E439B;
        font-size: 40px;
        font-weight: bold;
        margin-bottom: 30px;
        text-align: center;
    }
}

.info {
    margin-top: 60px;
    position: relative;
    height: 480px;
    border: 1px solid #E7E7E7;
    border-bottom: 0;

    .lunbo {
        position: absolute;
        bottom: 0;
        width: 100%;
        background-color: #fff;

        .text {
            height: 160px;
            padding: 30px 40px;
            padding-right: 180px;
            box-sizing: border-box;
            border-top: 1px solid #E7E7E7;
            border-bottom: 1px solid #E7E7E7;
        }
    }

    .lunbo-btn {
        position: absolute;
        bottom: 50px;
        right: 50px;
        z-index: 999;
        width: 50px;
        cursor: pointer;
    }

}

.tabinfo {
    margin-top: 150px;

    .tab {
        display: flex;
        justify-content: center;

        .item {
            margin: 0 24px;
            cursor: pointer;

            .text {
                margin-bottom: 10px;
                color: #B6B6B6;
                text-align: center;

                &.on {
                    font-weight: bold;
                    color: #333;
                    transition-duration: .3s;
                }
            }

            .line {
                width: 70px;
                height: 4px;
                background-color: #1E439B;
                opacity: 0;

                &.on {
                    opacity: 1;
                    transition-duration: .3s;
                }
            }
        }
    }

    .list {
        margin-top: 40px;
        width: 100%;
        overflow: hidden;
        position: relative;
        height: 280px;
        .box{
            display: flex;
            position: absolute;
            left: 0;
            width: 100%;
            transition-duration: .3s;
        }
        .item{
            width: 810px;
            display: flex;
            margin-right: 40px;
            .right{
                margin-left: 20px;
                width: 470px;
                position: relative;
                .list-title{
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 10px;
                }
                .btn{
                    color: #0256FF;
                    font-size: 18px;
                    font-weight: bold;
                    cursor: pointer;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    font-family: Source Han Sans;
                }
            }
        }
    }
}
</style>